'use client';

import { IconButton } from 'BomdisoftComponents/buttons/icon';
import { CheckRoundedIcon } from 'BomdisoftComponents/icons/check-rounded';
import { ContentCopyIcon } from 'BomdisoftComponents/icons/content-copy';
import { Tooltip } from 'BomdisoftComponents/tooltip/index';
import { connectAgentCopiedText, connectAgentCopyText, type SupportedLanguage } from '@bomdisoft/translations';
import { type ReactNode, useEffect, useState } from 'react';

export type AddressCopyProps = {
  language: SupportedLanguage;
  testId: string;
  value: string;
};

export const AddressCopy = ({ language, testId, value }: AddressCopyProps): ReactNode => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const label = copied ? connectAgentCopiedText[language] : connectAgentCopyText[language];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Tooltip placement='top' title={label}>
      <IconButton aria-label={label} data-copied={copied ? '' : undefined} data-testid={testId} onClick={() => void copy()} size='small'>
        {copied ? <CheckRoundedIcon size={18} /> : <ContentCopyIcon size={18} />}
      </IconButton>
    </Tooltip>
  );
};
